<ax-icon
  *ngIf="showIcon"
  class="icon type-icon"
  [name]="PropertyType.GENDER | propertyIcon"
></ax-icon>
<div>
  <div class="header">
    <div class="title">
      <label class="label"
        >{{ customLabel === '' ? (form.getRawValue() | propertyTypeLabel) : customLabel
        }}<span *ngIf="required">&nbsp;*</span></label
      >
    </div>
    <ax-clear-button
      matSuffix
      [form]="valueControl"
      *ngIf="hasValue && !valueControl.disabled && !readonly"
    ></ax-clear-button>
  </div>
  <mat-radio-group
    [name]="getName()"
    class="radio"
    [ngClass]="{readonly: readonly}"
    [formControl]="valueControl"
  >
    <mat-radio-button value="M" class="radio-item" type="radio">
      {{ 'label.male' | translate }}
    </mat-radio-button>
    <mat-radio-button value="F" class="radio-item" type="radio">
      {{ 'label.female' | translate }}
    </mat-radio-button>
  </mat-radio-group>

  <mat-hint class="hint" align="end">
    {{ hint }}
  </mat-hint>

  <ax-property-error *ngIf="valueControl.touched" [form]="form"></ax-property-error>
</div>
